// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"w2-z","displaySixCardTiles":"x2-z"};